(function (angular) {
    'use strict';

    angular.module('aprima-core-ui').factory('IntersectionObserverService', [
        '$log',
        IntersectionObserverService,
    ]);

    function IntersectionObserverService(
        $log
    ) {
        return {
            observeWithSelector: observeWithSelector,
        };

        function observeWithSelector(selector, observerCallback) {
            if('IntersectionObserver' in window) {
                var trackerElement = document.querySelector(selector);
                var intersectionObserver = new IntersectionObserver(observerCallback);
                intersectionObserver.observe(trackerElement);
                return intersectionObserver.disconnect.bind(intersectionObserver);
            }

            $log.debug('Browser doesn\'t support "IntersectionObserver".');
            return angular.noop;
        }
    }
})(window.angular);